import { ReactComponent as IconGoogle } from "../../assets/svg/icon-google.svg";

export default function GoogleSignInButton({
  label,
  onClick,
  disabled = false,
  loading = false,
  spinnerClassName = "spinner spinner-dark",
}) {
  return (
    <button
      type="button"
      className="ls-btn ls-btn-big"
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? <div className={spinnerClassName}></div> : <IconGoogle />}
      {!loading && label}
    </button>
  );
}
